export const GALLERY_REPRESENTATION_TEST_ID = 'galleryRepresentation';
